export const canUseDom = !!(typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    window.document &&
    window.document.createElement);
export let supportsPassive = false;
if (canUseDom) {
    try {
        const opts = {};
        Object.defineProperty(opts, 'passive', {
            get() {
                supportsPassive = true;
                return supportsPassive;
            },
        });
        window.addEventListener('test-passive', null, opts);
    }
    catch (e) { }
}
